import { connect } from 'react-redux';
import Pembayaran from '../../../../views/Finance/Spp/Pembayaran/Pembayaran.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';
import { getClasses } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
   
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Pembayaran);



